import { quickWebLogger } from '@quickweb/logger';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '@app/core/environment/environment.service'; // en4
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../../core/environment/environment.service";
var DatadogService = /** @class */ (function () {
    function DatadogService(http, environmentService) {
        this.http = http;
        this.environmentService = environmentService;
    }
    DatadogService.prototype.isInternalNetwork = function (url) {
        return this.http.get(url + '/hello', { responseType: "json" }).pipe(map(function () { return true; }), // Return true if status code is 200
        catchError(function (error) {
            if (error.status === 200) {
                return of(true); // Return true if status code is 200
            }
            return of(false); // Return false for other errors
        }));
    };
    DatadogService.prototype.configureDataDog = function () {
        var _this = this;
        // get env do en4 --- en4
        this.environmentService
            .loadEnvironment()
            .subscribe(function (res) {
            _this.envDatadog = res.datadogSettings; //set env
            // --- en4
            // --- datadog
            _this.isInternalNetwork(_this.envDatadog.ddproxy)
                .subscribe(function (internal) {
                console.log('isInternalNetwork', internal);
                _this.initializeDatadog(internal);
            });
            // --- datadog
            // --- en4
        });
        // --- en4
    };
    DatadogService.prototype.initializeDatadog = function (internal) {
        //config acesso interno com proxy
        var config = {
            name: this.envDatadog.name,
            version: this.envDatadog.version,
            env: this.envDatadog.environment,
            sigla: this.envDatadog.sigla,
            datadog: {
                logs: {
                    clientToken: this.envDatadog.proxyToken,
                    maskSensitiveData: true
                },
                rum: {
                    applicationId: this.envDatadog.applicationId,
                    clientToken: this.envDatadog.proxyToken,
                    sessionSampleRate: this.envDatadog.sessionSampleRate,
                    trackViewsManually: true,
                    maskSensitiveData: true
                }
            },
            externalApplication: false,
        };
        //ajuste config acesso externo sem proxy em prod
        if (!internal) {
            config.datadog.logs.clientToken = this.envDatadog.clientTokenExt;
            config.datadog.rum.clientToken = this.envDatadog.clientTokenExt;
            config.externalApplication = true;
        }
        //config datadog
        quickWebLogger.init(config);
        // console.log('dd config',config);
    };
    /**
    * Método que envia o erro para o datadog.
    * @param {string} message - mensagem que será enviada para ferramenta.
    */
    DatadogService.prototype.sendErrorLogs = function (message, context) {
        if (context === void 0) { context = {}; }
        quickWebLogger.logger.error(message, context);
    };
    /**
     * Método que envia o log para o datadog.
     * @param {string} message - mensagem que será enviada para ferramenta.
     */
    DatadogService.prototype.logInfo = function (message, context) {
        if (context === void 0) { context = {}; }
        quickWebLogger.logger.info(message, context);
    };
    /**
    * Método que envia o view para o datadog.
    */
    DatadogService.prototype.sendStartView = function (pagina, contexto) {
        var _context = contexto || {};
        quickWebLogger.rum.startView({ pageName: pagina, context: contexto });
    };
    /**
    * Método que envia o user para o datadog.
    */
    DatadogService.prototype.sendSetUser = function (_id, _name) {
        quickWebLogger.rum.setUser({ id: _id, name: _name });
    };
    /**
    * Método utilizado pelo MFE para enviar logs de erro para o datadog.
    */
    DatadogService.prototype.sendErrorLogsChildren = function (payload) {
        var analytics = payload.analytics;
        if (!this.validatePayload(analytics, 'dd'))
            return;
        var _a = this.formatMessage(analytics), message = _a.message, context = _a.context;
        this.sendErrorLogs(message, context);
    };
    DatadogService.prototype.validatePayload = function (payload, key) {
        return payload && typeof payload === 'object' && key in payload;
    };
    DatadogService.prototype.formatMessage = function (payload) {
        var _a = payload.dd, applicationUrl = _a.applicationUrl, statusCode = _a.statusCode, name = _a.name, erro = _a.erro, api = _a.api, ambiente = _a.ambiente, message = "status: " + statusCode + " nome-mfe: " + name + " url: " + applicationUrl, context = { erro: erro + ", api: " + api + ", ambiente: " + ambiente, name: name };
        return { message: message, context: context };
    };
    DatadogService.ngInjectableDef = i0.defineInjectable({ factory: function DatadogService_Factory() { return new DatadogService(i0.inject(i1.HttpClient), i0.inject(i2.EnvironmentService)); }, token: DatadogService, providedIn: "root" });
    return DatadogService;
}());
export { DatadogService };
